import Buybox from '@catalogo/ui-americanas-mobile-buybox';

export default Buybox;
